import { Component } from '@angular/core';

@Component({
  selector: 'app-score-skeleton',
  templateUrl: './score-skeleton.component.html',
  styleUrls: ['./score-skeleton.component.scss', '../score.component.scss'],
})
export class ScoreSkeletonComponent {}
